import { render, staticRenderFns } from "./userAccessManagement.vue?vue&type=template&id=217a72bc&"
import script from "./userAccessManagement.vue?vue&type=script&lang=js&"
export * from "./userAccessManagement.vue?vue&type=script&lang=js&"
import style0 from "./userAccessManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports